import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { connect } from "react-redux";
import { DataTypes } from "../../../../constants";

import Fetching from "../../../Common/Fetching";
import CategoryCard from "./CategoryCard";
import CourseCard from "../Course/CourseCard";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

import tmsActions from "../../../../actions/tmsActions";
import {
    getCategoryCourses,
    getLibraryCategory,
    isFetching,
} from "../../../../reducers";

const appCode = "C-TMS";

const Category = ({
    category,
    courses,
    isFetching,
    match,
    getCategoryDetails,
    getCategoryCourses,
}) => {
    useEffect(() => {
        getCategoryDetails(match.params.id, appCode);
        getCategoryCourses(match.params.id, appCode);
    }, [getCategoryDetails, getCategoryCourses, match.params.id]);

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {!!category && (
                    <Grid item xs={12}>
                        <CategoryCard category={category} />
                    </Grid>
                )}

                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!courses || !courses.length
                    ? null
                    : courses.map((data) => (
                          <Grid
                              item
                              lg={12}
                              xl={6}
                              key={data.id}
                              className="card-grid-item"
                          >
                              <CourseCard course={data} />
                          </Grid>
                      ))}
            </Grid>
        </Container>
    );
};

const mapStateToProps = (state, { match }) => ({
    category: getLibraryCategory(state, Number(match.params.id)),
    courses: getCategoryCourses(state, Number(match.params.id)),
    isFetching: isFetching(state, DataTypes.TMS_COURSES),
});

export default connect(mapStateToProps, {
    getCategoryDetails: tmsActions.getCategoryDetails,
    getCategoryCourses: tmsActions.getCategoryCourses,
})(Category);
